import React from 'react';
import SuggestionCardBase from '../SuggestionCardBase';
import { StringConstantsMixin } from '../../../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import BelayFacebookButton from '../../../buttons/BelayFacebookButton';

const {
  strings: {
    COMMUNITY: { FIND_YOUR_FRIENDS }
  }
} = StringConstantsMixin;

const FacebookSuggestionCard = () => {
  return (
    <SuggestionCardBase
      title="Facebook"
      subtext={FIND_YOUR_FRIENDS}
      imgSrc="https://cdn-assets.alltrails.com/assets/icons/facebook.svg"
      button={<BelayFacebookButton />}
    />
  );
};

export default FacebookSuggestionCard;
